import distributionWarehouseBrands from "@/GeneratedFixtures/DistributionWarehouseBrands.json";

// Only a listed brand can opt out (Amazon); a blank or unlisted one takes a
// deadline, because most of these warehouses book deliveries by due date.
// Older rows hold brands like "Walmart" rather than "walmart"; the backend
// ignores case when it looks a brand up, so this has to as well.
export function getDistributionWareHouseSupportsDeliveryDeadline(
  distributionWarehouseBrand: string | undefined,
): boolean {
  const identifier = distributionWarehouseBrand?.trim().toLowerCase();
  return (
    distributionWarehouseBrands.find((d) => d.identifier === identifier)
      ?.supportsDeliveryDeadline ?? true
  );
}
